import { render, staticRenderFns } from "./DiagHeader.vue?vue&type=template&id=f4a87230&"
import script from "./DiagHeader.vue?vue&type=script&lang=js&"
export * from "./DiagHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports